export default __webpack_public_path__ + "static/media/21_photo.b9750e4b.jpeg";